import React from "react";
import { Box } from "@mui/material";

export default function AppContainer({ children }) {
  return (
    <Box
      sx={{
        width: "100%",
        position: "relative",
      }}
    >
      {children}
    </Box>
  );
}
